import { LayoutType, withLayout } from 'hocs/with-layout';
import { OnboardingSubjectSelection } from './onboarding-subject-selection';

const WrappedOnboardingSubjectSelection = withLayout(
  LayoutType.WithOldNavOnly,
  OnboardingSubjectSelection,
);

export { WrappedOnboardingSubjectSelection as OnboardingSubjectSelection };
